import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FaqSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  const faqs = Array.from({ length: 10 }, (_, i) => ({
    q: t(`faq.q${i + 1}`),
    a: t(`faq.a${i + 1}`),
  }));

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-cream">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
      <div className="mx-auto w-full max-w-3xl px-4 py-16 md:px-6 md:py-20">
        <div className="text-center">
          <h2 className="font-heading text-2xl font-bold text-stone-900 md:text-3xl">
            {t('faq.title')}
          </h2>
          <p className="mt-3 text-sm text-stone-500 md:text-base">{t('faq.subtitle')}</p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="overflow-hidden rounded-lg border border-stone-200 bg-white"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-stone-50 cursor-pointer"
                >
                  <span className="text-sm font-semibold text-stone-800 md:text-base">{faq.q}</span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-base transition-colors ${
                      isOpen ? 'bg-emerald-600 text-white' : 'bg-stone-100 text-stone-500'
                    }`}
                  >
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-stone-600">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}